import React from "react";
import "./Footer.css";
import logoGovBRCor from "../../../../assets/logo/logo-footer-hubrasil.svg";

export function Footer() {
  return (
    <footer className="footerContent">
      <img
        className="logoFooterGovbr"
        alt="SUS, HU Brasil e Ministério da Educação"
        src={logoGovBRCor}
      />
    </footer>
  );
}
